<template>
  <div class="loader-container">
    <div class="loader-content">
      <img :src="src" alt="تحميل..." class="loader-gif" />
      <p class="loader-text">جاري التحميل...</p>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            src : require('../../assets/imgs/loader.gif')
        }
    }
}
</script>

<style scoped>
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
}

.loader-content {
  text-align: center;
}

.loader-gif {
  width: 120px;
  height: auto;
  margin-bottom: 15px;
}

.loader-text {
  color: #2abdc7;
  font-size: 1.2rem;
  font-weight: bold;
  font-family: Arial, sans-serif;
}
</style>
